<template>
  <div>
    <h2 class="mb-3">
      Import Has Finished
    </h2>
    <el-collapse
      v-model="activeName"
      accordion
    >
      <el-collapse-item
        :title="`Successful [${successMsgs.length}]`"
        name="1"
      >
        <div style="max-height: 25vh; overflow: scroll;">
          <div
            v-for="(msg, index) in successMsgs"
            :key="index"
          >
            <el-alert
              :title="msg"
              type="success"
              :closable="false"
              class="mb-1"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        :title="`Errors [${errorMsgs.length}]`"
        name="2"
      >
        <div style="max-height: 25vh; overflow: scroll;">
          <div
            v-for="(msg, index) in errorMsgs"
            :key="index"
          >
            <el-alert
              :title="msg[1]"
              type="error"
              :closable="false"
              class="mb-1"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  props: {
    successMsgs: {
      type: Array,
      required: false,
      default: () => []
    },
    errorMsgs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      activeName: '0',
      successCount: 0
    }
  }
}
</script>

<style>

</style>
